import { SvgIcon } from '@mui/material';
import { type ReactNode } from 'react';

import { api } from 'common';

import { PlaceholderAgentIcon } from './Placeholder';
import {
  AuthorizationAgentSvg,
  CallCenterAgentSvg,
  ChartScrubbingAgentSvg,
  ClinicalTrialsAgentSvg,
  FrontDeskAgentSvg,
  InpatientCareAgentSvg,
  MedicationAdherenceAgentSvg,
  PatientAgentSvg,
  PatientCareAgentSvg,
  QualityAgentSvg,
  RcmAgentSvg,
  ReferralsAgentSvg,
} from './SvgIcons';

export const AgentCategory = api.FlowAgent.AgentCategory;
export type AgentCategory = api.FlowAgent.AgentCategory;

const AGENT_CATEGORY_ICONS: Record<AgentCategory, ReactNode> = {
  [AgentCategory.Placeholder]: <PlaceholderAgentIcon />,
  [AgentCategory.Rcm]: <SvgIcon component={RcmAgentSvg} />,
  [AgentCategory.Authorization]: <SvgIcon component={AuthorizationAgentSvg} />,
  [AgentCategory.CallCenter]: <SvgIcon component={CallCenterAgentSvg} />,
  [AgentCategory.ChartScrubbing]: <SvgIcon component={ChartScrubbingAgentSvg} />,
  [AgentCategory.ClinicalTrials]: <SvgIcon component={ClinicalTrialsAgentSvg} />,
  [AgentCategory.FrontDesk]: <SvgIcon component={FrontDeskAgentSvg} />,
  [AgentCategory.InpatientCare]: <SvgIcon component={InpatientCareAgentSvg} />,
  [AgentCategory.MedicationAdherence]: <SvgIcon component={MedicationAdherenceAgentSvg} />,
  [AgentCategory.Patient]: <SvgIcon component={PatientAgentSvg} />,
  [AgentCategory.PatientCare]: <SvgIcon component={PatientCareAgentSvg} />,
  [AgentCategory.Quality]: <SvgIcon component={QualityAgentSvg} />,
  [AgentCategory.Referrals]: <SvgIcon component={ReferralsAgentSvg} />,
};

interface AgentCategoryIconProps {
  category: AgentCategory | string;
}

export function AgentCategoryIcon(props: AgentCategoryIconProps) {
  const { category } = props;
  return AGENT_CATEGORY_ICONS[category as AgentCategory] ?? <PlaceholderAgentIcon />;
}
